module.exports = __webpack_public_path__ + "img/screens.81919542.png";